// Размер видимой области по стороне `side` при заданном зуме (0 — без зума)
export const getZoomedSize = (params: {
  zoom: number
  side: 'width' | 'height'
  imageSize: {
    width: number
    height: number
  }
  sizeRestrictions: {
    minHeight: number
    minWidth: number
  }
}) => {
  const imageDimension = params.imageSize[params.side]

  const minDimension =
    params.side === 'width'
      ? params.sizeRestrictions.minWidth
      : params.sizeRestrictions.minHeight

  return imageDimension - params.zoom * (imageDimension - minDimension)
}
